export default __webpack_public_path__ + "b933ffcee61fdb16a7980cbd244fe434.png";